import { createModalContext } from 'modules/campaigns/lib/contexts';

export enum CampaignIndexModalType {
  ConfirmDisableAlertsModal = 'ConfirmDisableAlertsModal',
}

const CAMPAIGN_INDEX_PROVIDER_DEBUG_NAME = 'CampaignIndexModalProvider';

export type ModalProps = Record<string, any>;

export const {
  ModalContext: CampaignIndexModalContext,
  ModalProvider: CampaignIndexModalProvider,
  useModalContext: useCampaignIndexModalContext,
} = createModalContext<CampaignIndexModalType, ModalProps>(CAMPAIGN_INDEX_PROVIDER_DEBUG_NAME);
